import * as commonUtils from '@Common/Helpers/CommonUtils';
import { properties } from '@Common/Core/Properties';

export namespace Debugger {
    interface IDebug {
        writeln(msg: any): void;
    }

    class Debugger implements IDebug {
        private debugStab: IDebug = { writeln: $.noop };

        public writeln(msg: any): void {
            const debug = <IDebug>(window['Debug'] || this.debugStab);
            debug.writeln(msg);
        }
    }

    const _debugger = new Debugger();

    export function writeLn(msg: any): void {
        if (properties.isDebug) {
            _debugger.writeln(msg);
            commonUtils.log(msg);
        }
    }
}
